import { render, staticRenderFns } from "./showpush.vue?vue&type=template&id=0dd13665&scoped=true&"
import script from "./showpush.vue?vue&type=script&lang=js&"
export * from "./showpush.vue?vue&type=script&lang=js&"
import style0 from "./showpush.vue?vue&type=style&index=0&id=0dd13665&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd13665",
  null
  
)

export default component.exports